// extracted by mini-css-extract-plugin
export default {"main":"MeetingPoint-module_main_aX1TZq","meeting-point":"MeetingPoint-module_meeting-point_qNESqe","meetingPoint":"MeetingPoint-module_meeting-point_qNESqe"};